import React, { useState, useEffect } from 'react';
import { updateAgent } from '../utils/api';
import { mapErrorMessage } from '../utils/errorMapping';
import './_Buttons.css';
import './_Input.css';

const EditAgentModal = ({ agent, onClose, onAgentUpdated }) => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [contact_name, setContact_name] = useState('');
    const [description, setDescription] = useState('');
    const [agreement_start_date, setAgreement_start_date] = useState('');
    const [agreement_end_date, setAgreement_end_date] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    useEffect(() => {
        if (agent) {
            setName(agent.name || '');
            setEmail(agent.email || '');
            setPhone(agent.phone || '');
            setContact_name(agent.contact_name || '');
            setDescription(agent.description || '');
            setAgreement_start_date(agent.agreement_start_date ? agent.agreement_start_date.split('T')[0] : '');
            setAgreement_end_date(agent.agreement_end_date ? agent.agreement_end_date.split('T')[0] : '');
        }
    }, [agent]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        try {
            const payload = {
                name,
                contact_name,
                agreement_start_date,
                email: email || null,
                phone: phone || null,
                description: description,
                agreement_end_date: agreement_end_date || null,
            };
            await updateAgent(agent.id, payload);
            setSuccess('Agent updated successfully!');
            onAgentUpdated();
        } catch (error) {
            setError(mapErrorMessage(error.message));
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close" onClick={onClose}>X</button>
                <h2>Edit Agent</h2>
                {error && <p className="error">{error}</p>}
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <input
                            id="name"
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Name"
                        />
                    </div>
                    <div className="form-group">
                        <input
                            id="email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Email"
                        />
                    </div>
                    <div className="form-group">
                        <input
                            id="phone"
                            type="text"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            placeholder="Phone"
                        />
                    </div>
                    <div className="form-group">
                        <input
                            id="contact_name"
                            type="text"
                            value={contact_name}
                            onChange={(e) => setContact_name(e.target.value)}
                            placeholder="Contact Name"
                        />
                    </div>
                    <div className="form-group">
                        <textarea
                            id="description"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder="Description"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="agreement_start_date">Agreement Start Date</label>
                        <input
                            type="date"
                            id="agreement_start_date"
                            value={agreement_start_date}
                            onChange={(e) => setAgreement_start_date(e.target.value)}
                            placeholder="Agreement Start Date"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="agreement_end_date">Agreement End Date</label>
                        <input
                            type="date"
                            id="agreement_end_date"
                            value={agreement_end_date}
                            onChange={(e) => setAgreement_end_date(e.target.value)}
                            placeholder="Agreement End Date"
                        />
                    </div>
                    {success && <p className="success">{success}</p>}
                    <div className='actions-centered'>
                        <button onClick={onClose} className='cancel-button text-button'>Cancel</button>
                        <button type="submit" className="submit-button text-button">Update</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditAgentModal;